import { GraduationCap, Award, Building2, BookOpen } from "lucide-react";

const AboutLenses = () => {
  return (
    <section id="quem-sou" className="py-12 sm:py-16 lg:py-24 bg-secondary relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background via-secondary to-background opacity-70" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-gradient-blue opacity-5 blur-[120px] rounded-full" />
      
      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <div className="space-y-8 animate-fade-in">
          <div className="text-center space-y-4 mb-12">
            <div className="inline-block">
              <span className="text-accent font-inter text-sm uppercase tracking-wider px-4 py-2 rounded-full border border-accent/30 bg-accent/5">
                CRO-SP 132.903
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-kiona text-foreground font-bold">
              Quem Sou
            </h2>
            <p className="text-foreground/70 font-inter text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              Especialista em Dentística Estética e Cirurgia Plástica Periodontal e Peri-implantar
            </p>
            <p className="text-foreground/80 font-inter text-lg leading-relaxed max-w-3xl mx-auto">
              Cirurgiã-dentista graduada em Odontologia pela <span className="text-foreground font-semibold">Universidade Cidade de São Paulo (UNICID)</span>
            </p>
            <p className="text-foreground/80 font-inter text-base leading-relaxed max-w-4xl mx-auto mt-4">
              A Dra. Natália Piller atua há 7 anos em <strong>Dentística Estética</strong> e reabilitação do sorriso. Combina ciência e arte para transformar sorrisos com naturalidade e previsibilidade. É especialista em Dentística Estética e em Cirurgia Plástica Periodontal e Peri-implantar, com cursos em Harmonização Orofacial, gengivectomia e gengivoplastia. Autora de artigo científico (2020) sobre otimização da colagem de braquetes ortodônticos com fotoproteção e participante de projetos de iniciação científica, aplica conhecimento científico e atendimento acolhedor para personalizar cada tratamento.
            </p>
          </div>

          {/* Formação */}
          <div className="bg-card/50 border border-border/50 rounded-2xl p-6 md:p-8 hover:border-primary/30 transition-all hover-lift">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-gradient-blue flex items-center justify-center flex-shrink-0 shadow-blue">
                <GraduationCap className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <h3 className="font-inter font-semibold text-foreground text-xl mb-2">
                  Formação e Especialização
                </h3>
              </div>
            </div>
            <ul className="space-y-3 text-foreground/80 font-inter text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Graduação em <strong>Odontologia</strong> pela Universidade Cidade de São Paulo (UNICID)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Especialista em <strong>Dentística Estética</strong> – São Leopoldo Mandic</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Especialista em <strong>Cirurgia Plástica Periodontal e Peri-implantar</strong> – São Leopoldo Mandic</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Cursos complementares: <strong>Harmonização Orofacial</strong>; <strong>Gengivectomia e Gengivoplastia</strong></span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Autora de <strong>artigo científico</strong> (2020) sobre otimização da colagem de braquetes ortodônticos com recurso fotoprotetor</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent mt-1">•</span>
                <span>Participou de <strong>projetos de iniciação científica</strong> em materiais odontológicos e procedimentos clínicos</span>
              </li>
            </ul>
          </div>

          {/* Atuação */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-card/50 border border-border/50 rounded-2xl p-6 hover:border-accent/30 transition-all hover-lift">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center flex-shrink-0 shadow-blue">
                  <Building2 className="w-6 h-6 text-accent-foreground" />
                </div>
                <div>
                  <h3 className="font-inter font-semibold text-foreground text-xl">
                    Atuação Hospitalar
                  </h3>
                </div>
              </div>
              <p className="text-foreground/80 font-inter text-sm md:text-base leading-relaxed">
                Clínica odontológica especializada em <strong>Dentística Estética</strong>, <strong>Cirurgia Plástica Periodontal e Peri-implantar</strong> e <strong>Harmonização Facial</strong>, unindo saúde gengival, estética dental e harmonização orofacial com atendimento humanizado e técnicas baseadas em evidências.
              </p>
            </div>

            <div className="bg-card/50 border border-border/50 rounded-2xl p-6 hover:border-accent/30 transition-all hover-lift">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center flex-shrink-0 shadow-blue">
                  <Award className="w-6 h-6 text-accent-foreground" />
                </div>
                <div>
                  <h3 className="font-inter font-semibold text-foreground text-xl">
                    Clínica
                  </h3>
                </div>
              </div>
              <p className="text-foreground/80 font-inter text-sm md:text-base leading-relaxed">
                <strong>Clínica Smile & Beauty</strong> – Espaço moderno e acolhedor dedicado à excelência em estética dental e harmonização facial. Equipamentos de última geração e protocolos personalizados para cada paciente, sempre priorizando naturalidade e bem-estar.
              </p>
            </div>
          </div>

          {/* Professor */}
          <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20 rounded-2xl p-6 md:p-8">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center flex-shrink-0 shadow-blue">
                <BookOpen className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <h3 className="font-inter font-semibold text-foreground text-xl mb-2">
                  Docência
                </h3>
                <p className="text-foreground/80 font-inter text-sm md:text-base leading-relaxed">
                  Compartilha conhecimento sobre <strong>Estética Dental Integrada</strong>, evidência científica aplicada e técnicas baseadas em pesquisa
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutLenses;
